if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener(
          'product-info:loaded',
          function (event) {
            if (event && event.target && event.target.addPreProcessCallback) {
              event.target.addPreProcessCallback(this.preprocessHTML.bind(this));
            }
          }.bind(this)
        );
      }

      hide(preventFocus = false) {
        var cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      extractPath(rawUrl) {
        var url = String(rawUrl || '');
        var idx = 0;
        if (!url) return '';
        if (url.indexOf('://') > -1) {
          idx = url.indexOf('/', url.indexOf('://') + 3);
          if (idx === -1) return '/';
          return url.substring(idx) || '/';
        }
        return url;
      }

      normalizeFeaturedId(rawValue) {
        return String(rawValue || '').toLowerCase().replace(/-/g, '_');
      }

      getCustomColorProductBaseMap() {
        var raw = null;
        var out = null;
        if (this.customColorProductBaseMap) return this.customColorProductBaseMap;
        try {
          raw = window.paintscratchTheme && window.paintscratchTheme.psColorProductBaseMap
            ? window.paintscratchTheme.psColorProductBaseMap
            : null;
        } catch (_e) {
          raw = null;
        }
        if (raw && typeof raw === 'object') {
          this.customColorProductBaseMap = raw;
          return raw;
        }
        out = {
          pen: 'pen',
          'pen-tricoat': 'pen',
          'touch-up-paint-pen': 'pen',
          bottle: 'bottle',
          'bottle-tricoat': 'bottle',
          'touch-up-paint-bottle-2oz': 'bottle',
          spray: 'spray',
          'spray-tricoat': 'spray',
          'touch-up-paint-spray-can': 'spray',
          pro: 'pro',
          'pro-tricoat': 'pro',
          'touch-up-paint-pro-gallon': 'pro',
          'kit-pen': 'pen',
          'kit-pen-tricoat': 'pen',
          'touch-up-paint-kit-pen': 'pen',
          'kit-bottle': 'bottle',
          'kit-bottle-tricoat': 'bottle',
          'touch-up-paint-kit-bottle': 'bottle',
          'kit-spray': 'spray',
          'kit-spray-tricoat': 'spray',
          'touch-up-paint-kit-spray': 'spray'
        };
        this.customColorProductBaseMap = out;
        return out;
      }

      getCustomColorRouteHandleMap() {
        var raw = null;
        var out = null;
        if (this.customColorRouteHandleMap) return this.customColorRouteHandleMap;
        try {
          raw = window.paintscratchTheme && window.paintscratchTheme.psCustomColorRouteHandles
            ? window.paintscratchTheme.psCustomColorRouteHandles
            : null;
        } catch (_e) {
          raw = null;
        }
        if (raw && typeof raw === 'object') {
          this.customColorRouteHandleMap = raw;
          return raw;
        }
        out = {
          pro: true,
          'pro-tricoat': true,
          spray: true,
          'spray-tricoat': true,
          bottle: true,
          'bottle-tricoat': true,
          pen: true,
          'pen-tricoat': true,
          'kit-pen': true,
          'kit-bottle': true,
          'kit-spray': true,
          'kit-pen-tricoat': true,
          'kit-bottle-tricoat': true,
          'kit-spray-tricoat': true
        };
        this.customColorRouteHandleMap = out;
        return out;
      }

      extractLookupToken(rawValue) {
        var value = String(rawValue || '');
        var parts = null;
        var token = '';
        if (!value) return '';
        value = value.toLowerCase();
        if (value.indexOf('shopify://products/') > -1) {
          return value.split('shopify://products/').pop().split('?')[0].split('#')[0].split('/')[0];
        }
        if (value.indexOf('/products/') > -1) {
          return value.split('/products/').pop().split('?')[0].split('#')[0].split('/')[0];
        }
        if (value.indexOf('/colors/') > -1) {
          parts = value.split('/colors/').pop().split('?')[0].split('#')[0].split('/');
          if (parts.length > 2) return parts[2];
        }
        token = value.split('?')[0].split('#')[0];
        token = token.replace(/^\/+/, '').replace(/\/+$/, '');
        if (token.indexOf('/') > -1) {
          parts = token.split('/');
          token = parts[parts.length - 1];
        }
        return token;
      }

      isColorProductPath(path) {
        var value = String(path || '');
        var token = this.extractLookupToken(value);
        var routeMap = this.getCustomColorRouteHandleMap();
        if (!/^\/colors\/[^\/]+\/[^\/]+\/[^\/?#]+\/?$/i.test(value)) return false;
        return !!(token && routeMap[token]);
      }

      getCustomColorFeaturedAllowlist() {
        var raw = '';
        var parts = [];
        var out = {};
        var i = 0;
        var key = '';
        if (this.customColorFeaturedAllowlist) return this.customColorFeaturedAllowlist;
        try {
          raw = window.paintscratchTheme && window.paintscratchTheme.psCustomColorFeaturedIds
            ? String(window.paintscratchTheme.psCustomColorFeaturedIds)
            : 'ps_kits_regular,ps_kits_basecoat,ps_kits_tricoat,ps_products_regular,ps_products_tricoat';
        } catch (_e) {
          raw = 'ps_kits_regular,ps_kits_basecoat,ps_kits_tricoat,ps_products_regular,ps_products_tricoat';
        }
        parts = raw.split(',');
        for (i = 0; i < parts.length; i++) {
          key = this.normalizeFeaturedId(parts[i]);
          if (!key) continue;
          out[key] = true;
        }
        this.customColorFeaturedAllowlist = out;
        return out;
      }

      isAllowlistedFeaturedRoot(node) {
        var allowlist = this.getCustomColorFeaturedAllowlist();
        var featuredId = '';
        if (!node || !node.getAttribute) return false;
        featuredId = this.normalizeFeaturedId(node.getAttribute('data-ps-featured-id') || node.id || '');
        if (!featuredId) return false;
        return !!allowlist[featuredId];
      }

      hasCustomColorContext(opener) {
        var node = opener;
        var guard = 0;
        var flag = '';
        while (node && guard++ < 16) {
          if (node.getAttribute) {
            flag = String(node.getAttribute('data-ps-custom-color-product') || '').toLowerCase();
            if (flag === 'true') return true;
          }
          if (this.isAllowlistedFeaturedRoot(node)) return true;
          node = node.parentElement;
        }
        return false;
      }

      findCardRoot(opener) {
        var node = opener;
        var guard = 0;
        while (node && guard++ < 8) {
          if (
            node.matches &&
            node.matches('.card-wrapper, .product-card-wrapper, .card, .grid__item, .slider__slide, li')
          ) {
            return node;
          }
          node = node.parentElement;
        }
        return opener && opener.parentElement ? opener.parentElement : null;
      }

      findCardColorProductUrl(opener) {
        var root = this.findCardRoot(opener);
        var links = null;
        var href = '';
        var i = 0;
        if (!root || !root.querySelectorAll) return '';
        links = root.querySelectorAll('a[href*="/colors/"]');
        for (i = 0; i < links.length; i++) {
          href = this.extractPath(links[i].getAttribute ? links[i].getAttribute('href') : '');
          if (this.isColorProductPath(href)) return href;
        }
        return '';
      }

      normalizeProductBase(rawValue) {
        var token = this.extractLookupToken(rawValue);
        var map = this.getCustomColorProductBaseMap();
        if (token && map[token]) return map[token];
        if (token === 'pen' || token === 'bottle' || token === 'spray' || token === 'pro') return token;
        return '';
      }

      extractProductBase(rawUrl) {
        return this.normalizeProductBase(rawUrl);
      }

      buildColorProductUrl(opener, fallbackUrl) {
        var currentPath = window.location && window.location.pathname ? String(window.location.pathname) : '';
        var match = currentPath.match(/^\/colors\/([^\/]+)\/([^\/]+)(?:\/[^\/?#]+)?\/?$/i);
        var base = '';
        if (!match) return '';
        base = opener && opener.getAttribute ? this.normalizeProductBase(opener.getAttribute('data-ps-product-base') || '') : '';
        if (!base) base = this.extractProductBase(fallbackUrl);
        if (!base) return '';
        return '/colors/' + match[1] + '/' + match[2] + '/' + base;
      }

      resolveProductUrl(opener) {
        var rawUrl = opener && opener.getAttribute ? String(opener.getAttribute('data-product-url') || '') : '';
        var resolvedUrl = this.extractPath(rawUrl);
        if (this.isColorProductPath(resolvedUrl)) return resolvedUrl;

        resolvedUrl = this.findCardColorProductUrl(opener);
        if (resolvedUrl) return resolvedUrl;

        if (this.hasCustomColorContext(opener)) {
          resolvedUrl = this.buildColorProductUrl(opener, rawUrl);
          if (resolvedUrl) return resolvedUrl;
        }

        return rawUrl;
      }

      show(opener) {
        var self = this;
        var spinner = opener.querySelector('.loading__spinner');
        var productUrl = this.resolveProductUrl(opener);
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        if (spinner) spinner.classList.remove('hidden');
        if (productUrl && opener.getAttribute('data-product-url') !== productUrl) {
          opener.setAttribute('data-product-url', productUrl);
        }

        fetch(productUrl)
          .then(function (response) {
            return response.text();
          })
          .then(
            function (responseText) {
              var responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
              var productElement = responseHTML.querySelector('product-info');
              if (!productElement || !self.modalContent) return;

              self.preprocessHTML(productElement);
              HTMLUpdateUtility.setInnerHTML(self.modalContent, productElement.outerHTML);

              if (window.Shopify && Shopify.PaymentButton) {
                Shopify.PaymentButton.init();
              }
              if (window.ProductModel) window.ProductModel.loadShopifyXR();

              ModalDialog.prototype.show.call(self, opener);
            }
          )
          .finally(function () {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            if (spinner) spinner.classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        var classList = productElement && productElement.classList ? productElement.classList : [];
        var classApplied = '';
        var i = 0;
        for (i = 0; i < classList.length; i++) {
          classApplied = classList[i];
          if (classApplied.indexOf('color-') === 0 || classApplied === 'gradient') {
            this.modalContent.classList.add(classApplied);
          }
        }
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        var pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        var productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        var modalDialog = productElement.querySelectorAll('modal-dialog');
        var i = 0;
        if (!modalDialog) return;
        for (i = 0; i < modalDialog.length; i++) {
          modalDialog[i].remove();
        }
      }

      preventDuplicatedIDs(productElement) {
        var sectionId = productElement.dataset.section;
        var oldId = sectionId;
        var newId = 'quickadd-' + sectionId;
        var attributes = productElement.attributes || [];
        var attribute = null;
        var i = 0;
        if (oldId) {
          productElement.innerHTML = productElement.innerHTML.split(oldId).join(newId);
        }
        for (i = 0; i < attributes.length; i++) {
          attribute = attributes[i];
          if (attribute && attribute.value && attribute.value.indexOf(oldId) > -1) {
            productElement.setAttribute(attribute.name, attribute.value.split(oldId).join(newId));
          }
        }

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        var galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        var slides = null;
        var i = 0;
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        slides = galleryList.querySelectorAll('[id^="Slide-"]');
        for (i = 0; i < slides.length; i++) {
          slides[i].setAttribute('role', 'presentation');
        }
      }

      updateImageSizes(productElement) {
        var product = productElement.querySelector('.product');
        var desktopColumns = product && product.classList && product.classList.contains('product--columns');
        var mediaImages = null;
        var mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
        var i = 0;
        if (!desktopColumns) return;

        mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        for (i = 0; i < mediaImages.length; i++) {
          mediaImages[i].setAttribute('sizes', mediaImageSizes);
        }
      }
    }
  );
}
